'use client';

import { createContext } from 'react';

import type { UseFieldArrayReturn } from 'react-hook-form/dist/types';

export type FieldArrayContextState = UseFieldArrayReturn & { name: string };

const defaultValue: FieldArrayContextState = {
  fields: [],
  append: () => void 0,
  insert: () => void 0,
  move: () => void 0,
  prepend: () => void 0,
  remove: () => void 0,
  replace: () => void 0,
  swap: () => void 0,
  update: () => void 0,
  name: '',
};

export const FieldArrayContext = createContext<FieldArrayContextState>( defaultValue );
export const { Provider: FieldArrayProvider } = FieldArrayContext;
